import Rails from '@rails/ujs'
import contentPackagesApp from '@vuejs/pages/ContentPackagesPage'
import notificationWrapperApp from '@vuejs/pages/NotificationWrapper'
import packageManagementApp from '@vuejs/pages/PackageManagementPage'
import programManagementApp from '@vuejs/pages/ProgramManagementPage'
import $ from 'jquery'

import bootstrapNavbar from '@/javascript/components/bootstrap_navbar'
import caregiverDashboardEnabledCheckbox from '@/javascript/components/caregiver_dashboard_enabled_checkbox'
import initEitherOr from '@/javascript/components/either_or'
import initFlashMessages from '@/javascript/components/flash'
import initImageUpload from '@/javascript/components/image_upload'
import initInviteAdmin from '@/javascript/components/invite_admin'
import initMultiSelector from '@/javascript/components/multi_selector'
import initPopulateOrganizationIntegrationIds from '@/javascript/components/populate_organization_integration_ids'
import portalMigration from '@/javascript/components/portal_migration'
import portalMigrationToMainPortal from '@/javascript/components/portal_migration_to_main_portal'
import requirePublicNameForVisibleCurriculum from '@/javascript/components/require_public_name_for_visible_curriculum'
import showPortalMigrationStatus from '@/javascript/components/show_portal_migration_status'

// Load vue apps if element is on the page
const apps = [
	{ loader: contentPackagesApp, name: 'contentPackages' },
	{ loader: packageManagementApp, name: 'packageManagementApp' },
	{ loader: notificationWrapperApp, name: 'notificationWrapperApp' },
	{ loader: programManagementApp, name: 'programManagementApp' },
]

for (const app of apps) {
	const element = document.querySelector(`#${app.name}`)

	if (element) {
		app.loader()
	}
}

$(document).ready(function () {
	bootstrapNavbar()
	caregiverDashboardEnabledCheckbox()
	initFlashMessages()
	initEitherOr()
	initImageUpload()
	initInviteAdmin()
	initMultiSelector()
	initPopulateOrganizationIntegrationIds()
	portalMigration()
	portalMigrationToMainPortal()
	showPortalMigrationStatus()
	requirePublicNameForVisibleCurriculum()

	if (!window._rails_loaded) { Rails.start() }
})
